import { render, staticRenderFns } from "./AiIcon.vue?vue&type=template&id=2be2fa76&functional=true&"
import script from "./AiIcon.vue?vue&type=script&lang=js&"
export * from "./AiIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports